/** 实时路由 [实际,计划] 表实体类 */
import { Value } from "./PublicEntity";

export default class RouteEntity {
  constructor(routeentity?: RouteEntity) {
    if (routeentity) {
      Object.entries(routeentity).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  aggregateIndexTime?: Value;
  areaType?: Value;
  calcWeight?: number;
  carNo?: Value;
  carType?: Value;
  currentSystemTime?: Value;
  deliveryReceiptNo?: Value;
  destinationArea?: Value;
  destinationBigArea?: Value;
  destinationCenter?: Value;
  destinationCenterCode?: Value;
  destinationCity?: Value;
  destinationCounty?: Value;
  destinationLatitude?: Value;
  destinationLongitude?: Value;
  destinationProvince?: Value;
  destinationProvinceArea?: Value;
  destinationRegion?: Value;
  destinationSite?: Value;
  destinationSiteCode?: Value;
  goodsVolume?: number;
  goodsWeight?: number;
  isDestinationCenter?: Value;
  isOriginCenter?: Value;
  lengthOfTime?: Value;
  mustGoGoods?: Value;
  nextArea?: Value;
  nextBigArea?: Value;
  nextCity?: Value;
  nextCounty?: Value;
  nextLatitude?: Value;
  nextLongitude?: Value;
  nextProvince?: Value;
  nextProvinceArea?: Value;
  nextRegion?: Value;
  planNextSite?: Value;
  planNextSiteCode?: Value;
  nextSite?: Value;
  nextSiteCode?: Value;
  operateWeight?: number;
  originArea?: Value;
  originBigArea?: Value;
  originCenter?: Value;
  originCenterCode?: Value;
  originCity?: Value;
  originCounty?: Value;
  originLatitude?: Value;
  originLongitude?: Value;
  originProvince?: Value;
  originProvinceArea?: Value;
  originRegion?: Value;
  originSite?: Value;
  originSiteCode?: Value;
  piece?: number;
  preArea?: Value;
  preBigArea?: Value;
  preCity?: Value;
  preCounty?: Value;
  preLatitude?: Value;
  preLongitude?: Value;
  preProvince?: Value;
  preProvinceArea?: Value;
  preRegion?: Value;
  preSite?: Value;
  preSiteCode?: Value;
  productType?: Value;
  remark?: Value;
  routePath?: Value;
  scanArea?: Value;
  scanBigArea?: Value;
  scanCity?: Value;
  scanCounty?: Value;
  scanGoodsDepartureTime?: Value;
  scanLatitude?: Value;
  scanLongitude?: Value;
  scanProvince?: Value;
  scanProvinceArea?: Value;
  scanRegion?: Value;
  scanSite?: Value;
  scanSiteCode?: Value;
  scanType?: Value;
  subBillNo?: Value;
  superiorityProduct?: Value;
  taskNo?: Value;
  ticket?: number;
  trackLine?: Value;
  transportLineType?: Value;
  version?: Value;
  waybillNo?: Value;
}
